import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark1"><Path d="M4.5 12.5L10 19.25L19.5 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark1;
